(function() {
  'use strict';

  const CONTAINER_SELECTOR = '#downpay-due-today';
  const POLL_INTERVAL_MS = 800;
  let lastCartHash = '';

  // Money formatter, USD jer je Tvin USA LLC store
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function render(html) {
    const containers = document.querySelectorAll(CONTAINER_SELECTOR);
    containers.forEach(el => {
      el.innerHTML = html;
      el.style.display = html ? 'block' : 'none';
    });
  }

  function updateDueToday() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(r => r.json())
      .then(cart => {
        const hash = JSON.stringify({
          ids: cart.items.map(i => i.id + ':' + i.quantity + ':' + (i.selling_plan_allocation ? '1' : '0')),
          chargeAmount: cart.checkout_charge_amount
        });
        if (hash === lastCartHash) return;
        lastCartHash = hash;

        const hasDeposit = cart.items.some(item => item.selling_plan_allocation);

        if (!hasDeposit) {
          render('');
          return;
        }

        const dueToday = cart.checkout_charge_amount;
        const total = cart.total_price;
        const balance = total - dueToday;

        const html = `
          <div class="dp-due-wrapper">
            <div class="dp-due-row dp-due-row--primary">
              <span class="dp-due-label">Due today</span>
              <span class="dp-due-amount">${formatMoney(dueToday)}</span>
            </div>
            <div class="dp-due-row dp-due-row--secondary">
              <span class="dp-due-label-sub">Balance before shipping</span>
              <span class="dp-due-amount-sub">${formatMoney(balance)}</span>
            </div>
            <p class="dp-due-note">You won't be charged the balance until your order ships.</p>
          </div>
        `;
        render(html);
      })
      .catch(err => console.warn('[Downpay] cart fetch failed', err));
  }

  // Initial run
  document.addEventListener('DOMContentLoaded', updateDueToday);

  // Hook na sve cart mutacije kroz fetch
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = (args[0] || '').toString();
    return originalFetch.apply(this, args).then(response => {
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        response.clone().json().catch(() => {}).finally(() => {
          setTimeout(updateDueToday, 150);
        });
      }
      return response;
    });
  };

  // Hook na XHR (legacy AJAX, neki apovi koriste)
  const originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      this.addEventListener('load', () => setTimeout(updateDueToday, 150));
    }
    return originalXHROpen.apply(this, arguments);
  };

  // Custom events koje Shopify themes i neke apovi emit-aju
  ['cart:updated', 'cart:refresh', 'cart:changed', 'cart:open', 'ajaxCart.afterCartLoad']
    .forEach(evt => document.addEventListener(evt, updateDueToday));

  // Fallback polling kad je Essential drawer vidljiv
  setInterval(() => {
    const drawer = document.querySelector(
      '[class*="essential-cart"], [class*="ea-cart"], [data-essential-cart-drawer], [class*="cart-drawer"]'
    );
    if (drawer && drawer.offsetParent !== null) {
      updateDueToday();
    }
  }, POLL_INTERVAL_MS);

  // MutationObserver za drawer open/close
  const observer = new MutationObserver(() => {
    const drawerOpen = document.querySelector(
      '.cart-drawer.open, [class*="cart"][class*="open"], [aria-hidden="false"][class*="cart"]'
    );
    if (drawerOpen) updateDueToday();
  });
  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class', 'aria-hidden', 'style']
  });
})();